(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34],{

/***/ 15250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_list_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56723);

/* harmony default export */ __webpack_exports__["default"] = (_components_list_index__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 2848:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/list",
      function () {
        return __webpack_require__(15250);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [274,585,358,723,774,888,179], function() { return __webpack_exec__(2848); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);